//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getReadIds, cleanupReadIds } from '~/utils/importantAnnounceRead'

const MAX_DISPLAY_COUNT = 3

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      readIds: [],
      readStateReady: false,
    }
  },

  computed: {
    cid() {
      return this.$auth?.user?.cid || null
    },
    filteredList() {
      return this.list
        .filter((item) => !this.readIds.includes(item.id))
        .map((item) => ({
          ...item,
          link: `/news/detail?id=${item.id}`,
        }))
        .slice(0, MAX_DISPLAY_COUNT)
    },
  },

  mounted() {
    const cid = this.cid
    const importantAnnounceIds = this.list.map((a) => a.id)

    if (cid) {
      cleanupReadIds(cid, importantAnnounceIds)
      this.readIds = getReadIds(cid)
    }
    this.readStateReady = true

    if (this.filteredList.length > 0 && this.$gtag) {
      this.$gtag.event('announce_impression', {
        announce_section: 'important',
        announce_impression_value: 1,
      })
    }
  },

  methods: {
    onClickAnnounce(item) {
      if (this.$gtag) {
        this.$gtag.event('announce_click', {
          announce_id: item.id,
          announce_section: 'important',
          announce_click_value: 1,
        })
      }
    },
  },
}
